/** @file What playback runs over: the document fps and the loop range, else the whole animation. */
import type { Doc } from '@pose2d/format/types';
import type { PlayheadSlice } from '../stores/types';
import { animationFrames } from './animationFrames';

/** Frames per second and the [start, end) frame range playback wraps in. */
export interface PlayClip {
  fps: number;
  start: number;
  end: number;
}

/** null without a document or a current animation (or when the animation was deleted). */
export function playClip(doc: Doc | null, slice: PlayheadSlice): PlayClip | null {
  const anim = doc === null || slice.animation === null ? undefined : doc.animations[slice.animation];
  if (doc === null || anim === undefined) return null;
  const [start, end] = slice.loop ?? [0, animationFrames(anim)];
  return { fps: doc.meta.fps, start, end };
}
